import { render } from "./question5.vue?vue&type=template&id=b2b6c1f2&scoped=true"
import script from "./question5.vue?vue&type=script&lang=js"
export * from "./question5.vue?vue&type=script&lang=js"

import "./question5.vue?vue&type=style&index=0&id=b2b6c1f2&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b6c1f2"]])

export default __exports__